import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

let swiperInstance = null;

const initializeSwiperMorningCall = () => {
  const morningCallSection = document.getElementById("morning-call-section");
  if (!morningCallSection) return;

  const initSwiper = () => {
    swiperInstance?.destroy(true, true); // Destroi anterior
    swiperInstance = new Swiper(".morningCallSwiper", {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 32,
      loop: true,
      slideToClickedSlide: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".morningCall-next",
        prevEl: ".morningCall-prev",
      },
      pagination: {
        el: ".morningCall-pagination",
        clickable: true,
      },
      on: {
        slideChange: function () {
          updateSlideOpacity(this);
        },
        init: function () {
          updateSlideOpacity(this);
        },
      },
    });
  };

  const updateSlideOpacity = (swiperInstance) => {
    swiperInstance.slides.forEach(slide => {
      slide.style.opacity = '0.5';
    });
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (activeSlide) activeSlide.style.opacity = '1';
  };

  initSwiper(); // inicial

  // Modal vídeo (player embutido do YouTube, com modo mini). Os conjuntos de
  // classes vêm de data-attributes do template para o Tailwind compilá-los.
  const modal = document.getElementById("morningCallModal");
  const iframe = document.getElementById("morningCallIframe");
  const classeCheio = modal?.getAttribute("data-class-cheio");
  const classeMini = modal?.getAttribute("data-class-mini");

  const modalEstaMini = () => !modal.classList.contains("bg-black/80");

  const abrirModal = (embed) => {
    iframe.setAttribute("src", `${embed}?autoplay=1`);
    modal.className = classeCheio;
    document.body.classList.add("overflow-hidden");
  };

  // Reposiciona sem recarregar o iframe: o vídeo continua tocando.
  const minimizarModal = () => {
    modal.className = classeMini;
    document.body.classList.remove("overflow-hidden");
  };

  const expandirModal = () => {
    modal.className = classeCheio;
    document.body.classList.add("overflow-hidden");
  };

  const fecharModal = () => {
    modal.className = `hidden ${classeCheio}`;
    iframe.setAttribute("src", ""); // interrompe a reprodução
    document.body.classList.remove("overflow-hidden");
  };

  // Delegação: o Swiper (loop) e o filtro por mês CLONAM os slides, e clones
  // não carregam listeners individuais — o listener fica na seção.
  morningCallSection.addEventListener('click', (e) => {
    const el = e.target.closest('[data-morning-video]');
    if (!el) return;
    const embed = el.getAttribute("data-video-embed");
    const link = el.getAttribute("data-video-link");
    if (embed && modal && iframe) {
      abrirModal(embed);
    } else if (link) {
      // vídeo fora do YouTube: abre o link direto
      window.open(link, "_blank");
    }
  });

  modal?.querySelector(".close-modal")?.addEventListener("click", fecharModal);
  modal?.querySelector(".mini-modal")?.addEventListener("click", () => {
    modalEstaMini() ? expandirModal() : minimizarModal();
  });
  modal?.addEventListener("click", (e) => {
    if (e.target === modal) fecharModal();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal && !modal.classList.contains("hidden")) fecharModal();
  });
};

export default initializeSwiperMorningCall;
